export default __webpack_public_path__ + "static/media/illustration-packages.7cb6973d.svg";